import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Card from '../../layout/Card';
import ModuleHome from '../../layout/ModuleHome';
import { breadcrumbsPropTypes } from '../../common/resource/proptypes/CommonPropTypes';

const SystemHome = ({ cards, breadcrumbs }) => (
  <ModuleHome
    title="Sistema"
    text="Éste es el módulo de Sistema."
    cards={cards}
    breadcrumbs={breadcrumbs}
  />
);

const mapStateToProps = (state) => ({
  cards: state.SystemUnit.UnitHome.get('cards'),
  breadcrumbs: state.SystemUnit.UnitHome.get('breadcrumbs'),
});

SystemHome.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  cards: PropTypes.arrayOf(PropTypes.shape(Card.propTypes)).isRequired,
};

export default connect(mapStateToProps)(SystemHome);
